import { RootState } from '@store/rootReducer'

export const selectFonts = (state: RootState) => state.editor.fonts.fonts
export const selectFontPacks = (state: RootState) => state.editor.fonts.fontPacks
export const selectFontGroups = (state: RootState) => state.editor.fonts.fontGroups
export const selectFontsLoading = (state: RootState) => state.editor.fonts.isLoading
export const selectFontsLoaded = (state: RootState) => state.editor.fonts.isLoaded

export const selectFontNameByFamily = (state: RootState, fontFamily: string): string => {
  const fonts = state.editor.fonts.fonts
  const font = fonts.find(f => f.family === fontFamily)
  return font?.name ?? fontFamily
}

